<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  message: {
    type: String,
    default: ''
  },
  warning: {
    type: String,
    default: ''
  },
  validateButton: {
    type: String,
    default: ''
  },
  cancelButton: {
    type: String,
    default: ''
  },
  validateDisabled: {
    type: Boolean,
    default: false
  },
  validateLoading: {
    type: Boolean,
    default: false
  },
  cancelDisabled: {
    type: Boolean,
    default: false
  },
  variant: {
    type: String,
    default: 'default',
    validator: (value) => ['default', 'destructive'].includes(value)
  }
})

const emit = defineEmits(['closeModal'])
const { t } = useI18n()

const validateColor = computed(() => (props.variant === 'destructive' ? 'error' : undefined))
</script>

<template>
  <v-card>
    <p class="text-h6 font-weight-bold mb-3">
      {{ title }}
    </p>
    <p v-if="message" class="text-body-2 text-medium-emphasis text-pre-line mb-6">
      {{ message }}
    </p>
    <p v-if="warning" class="text-body-2 text-error text-pre-line mb-6">
      {{ warning }}
    </p>
    <slot />
    <div class="d-flex justify-end flex-wrap ga-4">
      <v-btn
        :disabled="cancelDisabled"
        data-testid="modal-cancel"
        variant="tonal"
        @click="emit('closeModal', false)"
      >
        {{ cancelButton || t('COMMON.BUTTON.CANCEL') }}
      </v-btn>
      <v-btn
        :color="validateColor"
        :disabled="validateDisabled"
        :loading="validateLoading"
        data-testid="modal-validate"
        @click="emit('closeModal', true)"
      >
        {{ validateButton || t('COMMON.BUTTON.VALIDATE') }}
      </v-btn>
    </div>
  </v-card>
</template>
